/**
 * @generated SignedSource<<2079850f542ae8af0b1c072e746e49b5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type inProductInviterNotif_personalSettingsDigestNotifications_InProductInviterNotification$data = {
  readonly projectInviterNotification: {
    readonly id: string;
    readonly inProductChannel: {
      readonly isEnabled: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "inProductInviterNotif_personalSettingsDigestNotifications_InProductInviterNotification";
};
export type inProductInviterNotif_personalSettingsDigestNotifications_InProductInviterNotification$key = {
  readonly " $data"?: inProductInviterNotif_personalSettingsDigestNotifications_InProductInviterNotification$data;
  readonly " $fragmentSpreads": FragmentRefs<"inProductInviterNotif_personalSettingsDigestNotifications_InProductInviterNotification">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "inProductInviterNotif_personalSettingsDigestNotifications_InProductInviterNotification",
  "selections": [
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "projectInviterNotification",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "id"
          },
          "action": "THROW",
          "path": "projectInviterNotification.id"
        },
        {
          "concreteType": "JiraNotificationChannel",
          "kind": "LinkedField",
          "name": "inProductChannel",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isEnabled"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraNotificationPreferences"
};

(node as any).hash = "d50055f2472657ee6443df4182ea21bb";

export default node;
